import React, { FC } from 'react';

interface SVGGiftProps {
  width?: string;
  height?: string;
  color?: string;
  strokeWidth?: string;
}

const SVGGiftIcon: FC<SVGGiftProps> = ({
  width = '25',
  height = '24',
  color = 'black',
  strokeWidth = '2',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5 12V22H4.5V12"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.5 7H2.5V12H22.5V7Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 22V7"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 7H8C7.33696 7 6.70107 6.73661 6.23223 6.26777C5.76339 5.79893 5.5 5.16304 5.5 4.5C5.5 3.83696 5.76339 3.20107 6.23223 2.73223C6.70107 2.26339 7.33696 2 8 2C11.5 2 12.5 7 12.5 7Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 7H17C17.663 7 18.2989 6.73661 18.7678 6.26777C19.2366 5.79893 19.5 5.16304 19.5 4.5C19.5 3.83696 19.2366 3.20107 18.7678 2.73223C18.2989 2.26339 17.663 2 17 2C13.5 2 12.5 7 12.5 7Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVGGiftIcon;
